var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5995 3.27157L9.15555 0.82813C9.0743 0.746857 8.97783 0.682387 8.87166 0.638402C8.76548 0.594417 8.65169 0.571777 8.53676 0.571777C8.42184 0.571777 8.30804 0.594417 8.20187 0.638402C8.0957 0.682387 7.99923 0.746857 7.91797 0.82813L1.17446 7.57164C1.09285 7.6526 1.02815 7.74897 0.984123 7.85515C0.940091 7.96134 0.917606 8.07521 0.917973 8.19016V10.6341C0.917973 10.8662 1.01016 11.0888 1.17425 11.2529C1.33835 11.417 1.56091 11.5091 1.79297 11.5091H10.9805C11.0965 11.5091 11.2078 11.4631 11.2898 11.381C11.3719 11.299 11.418 11.1877 11.418 11.0716C11.418 10.9556 11.3719 10.8443 11.2898 10.7623C11.2078 10.6802 11.0965 10.6341 10.9805 10.6341H5.47454L11.5995 4.50914C11.6808 4.42789 11.7453 4.33142 11.7893 4.22525C11.8332 4.11908 11.8559 4.00528 11.8559 3.89036C11.8559 3.77543 11.8332 3.66163 11.7893 3.55546C11.7453 3.44929 11.6808 3.35282 11.5995 3.27157ZM9.66797 5.20313L7.22454 2.75915L8.53704 1.44665L10.9805 3.89063L9.66797 5.20313Z",
    fill: "#545B7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/Pen.bb6c4608.svg";
export { ForwardRef as ReactComponent };